export const teamMembersTranslations: Record<string, {
  title: string;
  description: string;
  add_user: string;
  all_team_members: string;
  members_count: string;
  members_count_plural: string;
  in_your_team: string;
  add_user_title: string;
  add_user_description: string;
  first_name: string;
  last_name: string;
  email: string;
  password: string;
  confirm_password: string;
  permissions: string;
  owner: string;
  admin: string;
  user: string;
  read_only: string;
  role_admin_desc: string;
  role_user_desc: string;
  role_readonly_desc: string;
  edit_user_title: string;
  edit_user_description: string;
  save_changes: string;
  cancel: string;
  error_load: string;
  error_create: string;
  error_update: string;
  error_delete: string;
  success_create: string;
  limit_reached: string;
  upgrade: string;
  error_required_fields: string;
  error_password_mismatch: string;
  password_requirements_hint: string;
  delete_user_title: string;
  delete_user_description: string;
  delete_user: string;
  generate_password: string;
  show_password: string;
  hide_password: string;
}> = {
  pt: {
    title: "Membros da Equipa",
    description: "Gerir a sua equipa e as permissões de acesso",
    add_user: "Adicionar Utilizador",
    all_team_members: "Todos os Membros da Equipa",
    members_count: "membro",
    members_count_plural: "membros",
    in_your_team: "na sua equipa",
    add_user_title: "Adicionar utilizador",
    add_user_description: "Adicionar um novo membro à sua organização",
    first_name: "Primeiro Nome",
    last_name: "Último Nome",
    email: "Email",
    password: "Palavra-passe",
    confirm_password: "Confirmar palavra-passe",
    permissions: "Permissões",
    owner: "Proprietário",
    admin: "Administrador",
    user: "Membro",
    read_only: "Apenas Leitura",
    role_admin_desc: "Acesso sem restrições a todas as contas financeiras.",
    role_user_desc:
      "Acesso limitado às contas financeiras. Permissões de acesso definidas por Proprietários e Administradores.",
    role_readonly_desc:
      "Acesso apenas de leitura ao Fluxo de Caixa e Relatórios para certas contas financeiras. Permissões de acesso definidas por Proprietários e Administradores.",
    edit_user_title: "Editar utilizador",
    edit_user_description: "Atualizar informações e permissões do membro da equipa",
    save_changes: "Guardar Alterações",
    cancel: "Cancelar",
    error_load: "Não foi possível carregar os membros da equipa.",
    error_create: "Não foi possível adicionar o utilizador.",
    error_update: "Não foi possível atualizar o utilizador.",
    error_delete: "Não foi possível remover o utilizador.",
    success_create: "Utilizador adicionado com sucesso.",
    limit_reached: "Limite de utilizadores atingido",
    upgrade: "Fazer upgrade",
    error_required_fields: "Preencha todos os campos obrigatórios.",
    error_password_mismatch: "As palavras-passe não coincidem.",
    password_requirements_hint:
      "A palavra-passe deve ter pelo menos 8 caracteres, 1 maiúscula, 1 minúscula e 1 número.",
    delete_user_title: "Eliminar utilizador",
    delete_user_description: "Tem a certeza que pretende eliminar {{name}}?",
    delete_user: "Eliminar utilizador",
    generate_password: "Gerar palavra-passe forte",
    show_password: "Mostrar palavra-passe",
    hide_password: "Ocultar palavra-passe",
  },
  en: {
    title: "Team Members",
    description: "Manage your team and access permissions",
    add_user: "Add User",
    all_team_members: "All Team Members",
    members_count: "member",
    members_count_plural: "members",
    in_your_team: "in your team",
    add_user_title: "Add user",
    add_user_description: "Add a new member to your organization",
    first_name: "First Name",
    last_name: "Last Name",
    email: "Email",
    password: "Password",
    confirm_password: "Confirm password",
    permissions: "Permissions",
    owner: "Owner",
    admin: "Administrator",
    user: "Member",
    read_only: "Read Only",
    role_admin_desc: "Unrestricted access to all financial accounts.",
    role_user_desc:
      "Limited access to financial accounts. Access permissions defined by Owners and Administrators.",
    role_readonly_desc:
      "Read-only access to Cash Flow and Reports for certain financial accounts. Access permissions defined by Owners and Administrators.",
    edit_user_title: "Edit user",
    edit_user_description: "Update information and permissions of team member",
    save_changes: "Save Changes",
    cancel: "Cancel",
    error_load: "Failed to load team members.",
    error_create: "Failed to add user.",
    error_update: "Failed to update user.",
    error_delete: "Failed to remove user.",
    success_create: "User added successfully.",
    limit_reached: "User limit reached",
    upgrade: "Upgrade",
    error_required_fields: "Please fill in all required fields.",
    error_password_mismatch: "Passwords do not match.",
    password_requirements_hint:
      "Password must be at least 8 characters and include 1 uppercase, 1 lowercase, and 1 number.",
    delete_user_title: "Delete user",
    delete_user_description: "Are you sure you want to delete {{name}}?",
    delete_user: "Delete user",
    generate_password: "Generate strong password",
    show_password: "Show password",
    hide_password: "Hide password",
  },
  es: {
    title: "Miembros del Equipo",
    description: "Administrar tu equipo y permisos de acceso",
    add_user: "Agregar Usuario",
    all_team_members: "Todos los Miembros del Equipo",
    members_count: "miembro",
    members_count_plural: "miembros",
    in_your_team: "en tu equipo",
    add_user_title: "Agregar usuario",
    add_user_description: "Agregar un nuevo miembro a tu organización",
    first_name: "Nombre",
    last_name: "Apellido",
    email: "Correo electrónico",
    password: "Contraseña",
    confirm_password: "Confirmar contraseña",
    permissions: "Permisos",
    owner: "Propietario",
    admin: "Administrador",
    user: "Miembro",
    read_only: "Solo lectura",
    role_admin_desc: "Acceso sin restricciones a todas las cuentas financieras.",
    role_user_desc:
      "Acceso limitado a las cuentas financieras. Permisos de acceso definidos por Propietarios y Administradores.",
    role_readonly_desc:
      "Acceso solo de lectura al Flujo de Caja y Informes para ciertas cuentas financieras. Permisos de acceso definidos por Propietarios y Administradores.",
    edit_user_title: "Editar usuario",
    edit_user_description: "Actualizar información y permisos del miembro del equipo",
    save_changes: "Guardar Cambios",
    cancel: "Cancelar",
    error_load: "No se pudieron cargar los miembros del equipo.",
    error_create: "No se pudo agregar el usuario.",
    error_update: "No se pudo actualizar el usuario.",
    error_delete: "No se pudo eliminar el usuario.",
    success_create: "Usuario agregado correctamente.",
    limit_reached: "Se alcanzó el límite de usuarios",
    upgrade: "Mejorar",
    error_required_fields: "Completa todos los campos obligatorios.",
    error_password_mismatch: "Las contraseñas no coinciden.",
    password_requirements_hint:
      "La contraseña debe tener al menos 8 caracteres e incluir 1 mayúscula, 1 minúscula y 1 número.",
    delete_user_title: "Eliminar usuario",
    delete_user_description: "¿Seguro que quieres eliminar a {{name}}?",
    delete_user: "Eliminar usuario",
    generate_password: "Generar contraseña segura",
    show_password: "Mostrar contraseña",
    hide_password: "Ocultar contraseña",
  },
  et: {
    title: "Meeskonnaliikmed",
    description: "Haldage oma meeskonda ja ligipääsuõigusi",
    add_user: "Lisa kasutaja",
    all_team_members: "Kõik meeskonnaliikmed",
    members_count: "liige",
    members_count_plural: "liiget",
    in_your_team: "sinu meeskonnas",
    add_user_title: "Lisa kasutaja",
    add_user_description: "Lisa uus liige oma organisatsiooni",
    first_name: "Eesnimi",
    last_name: "Perekonnanimi",
    email: "E-post",
    password: "Parool",
    confirm_password: "Kinnita parool",
    permissions: "Ligipääsuõigused",
    owner: "Omanik",
    admin: "Administraator",
    user: "Liige",
    read_only: "Ainult lugemine",
    role_admin_desc: "Ligipääs kõigile finantskontodele ilma piiranguteta.",
    role_user_desc:
      "Piiratud ligipääs finantskontodele. Ligipääsuõigused määrab Omad ja Administraatorid.",
    role_readonly_desc:
      "Lugemise ligipääs Rahavoogile ja Aruannetele mõnes finantskontodel. Ligipääsuõigused määrab Omad ja Administraatorid.",
    edit_user_title: "Muuda kasutajat",
    edit_user_description: "Värskenda meeskonnaliikme teavet ja ligipääsuõigusi",
    save_changes: "Salvesta muudatused",
    cancel: "Tühista",
    error_load: "Meeskonnaliikmete laadimine ebaõnnestus.",
    error_create: "Kasutaja lisamine ebaõnnestus.",
    error_update: "Kasutaja uuendamine ebaõnnestus.",
    error_delete: "Kasutaja eemaldamine ebaõnnestus.",
    success_create: "Kasutaja lisatud.",
    limit_reached: "Kasutajate limiit on täis",
    upgrade: "Uuenda",
    error_required_fields: "Täida kõik kohustuslikud väljad.",
    error_password_mismatch: "Paroolid ei kattu.",
    password_requirements_hint:
      "Parool peab olema vähemalt 8 tähemärki ja sisaldama 1 suurtähte, 1 väiketähte ning 1 numbrit.",
    delete_user_title: "Kustuta kasutaja",
    delete_user_description: "Kas oled kindel, et soovid kustutada {{name}}?",
    delete_user: "Kustuta kasutaja",
    generate_password: "Loo tugev parool",
    show_password: "Kuva parool",
    hide_password: "Peida parool",
  },
  de: {
    title: "Teammitglieder",
    description: "Verwalten Sie Ihr Team und Zugriffsberechtigungen",
    add_user: "Benutzer hinzufügen",
    all_team_members: "Alle Teammitglieder",
    members_count: "Mitglied",
    members_count_plural: "Mitglieder",
    in_your_team: "in Ihrem Team",
    add_user_title: "Benutzer hinzufügen",
    add_user_description: "Neues Mitglied zur Organisation hinzufügen",
    first_name: "Vorname",
    last_name: "Nachname",
    email: "E-Mail",
    password: "Passwort",
    confirm_password: "Passwort bestätigen",
    permissions: "Berechtigungen",
    owner: "Inhaber",
    admin: "Administrator",
    user: "Mitglied",
    read_only: "Nur Lesen",
    role_admin_desc: "Uneingeschränkter Zugriff auf alle Finanzkonten.",
    role_user_desc: "Eingeschränkter Zugriff auf Finanzkonten.",
    role_readonly_desc: "Nur-Lese-Zugriff auf Cashflow und Berichte.",
    edit_user_title: "Benutzer bearbeiten",
    edit_user_description: "Informationen des Teammitglieds aktualisieren",
    save_changes: "Änderungen speichern",
    cancel: "Abbrechen",
    error_load: "Teammitglieder konnten nicht geladen werden.",
    error_create: "Benutzer konnte nicht hinzugefügt werden.",
    error_update: "Benutzer konnte nicht aktualisiert werden.",
    error_delete: "Benutzer konnte nicht entfernt werden.",
    success_create: "Benutzer wurde hinzugefügt.",
    limit_reached: "Benutzerlimit erreicht",
    upgrade: "Aktualisieren",
    error_required_fields: "Bitte alle Pflichtfelder ausfüllen.",
    error_password_mismatch: "Passwörter stimmen nicht überein.",
    password_requirements_hint:
      "Das Passwort muss mindestens 8 Zeichen lang sein und 1 Großbuchstaben, 1 Kleinbuchstaben und 1 Zahl enthalten.",
    delete_user_title: "Benutzer löschen",
    delete_user_description: "Möchten Sie {{name}} wirklich löschen?",
    delete_user: "Benutzer löschen",
    generate_password: "Sicheres Passwort erzeugen",
    show_password: "Passwort anzeigen",
    hide_password: "Passwort verbergen",
  },
  fr: {
    title: "Membres de l'équipe",
    description: "Gérer votre équipe et les permissions d'accès",
    add_user: "Ajouter un Utilisateur",
    all_team_members: "Tous les Membres de l'équipe",
    members_count: "membre",
    members_count_plural: "membres",
    in_your_team: "dans votre équipe",
    add_user_title: "Ajouter un utilisateur",
    add_user_description: "Ajouter un nouveau membre à votre organisation",
    first_name: "Prénom",
    last_name: "Nom",
    email: "E-mail",
    password: "Mot de passe",
    confirm_password: "Confirmer le mot de passe",
    permissions: "Permissions",
    owner: "Propriétaire",
    admin: "Administrateur",
    user: "Membre",
    read_only: "Lecture Seule",
    role_admin_desc: "Accès illimité à tous les comptes financiers.",
    role_user_desc: "Accès limité aux comptes financiers.",
    role_readonly_desc: "Accès en lecture seule au flux de trésorerie et aux rapports.",
    edit_user_title: "Modifier l'utilisateur",
    edit_user_description: "Mettre à jour les informations du membre",
    save_changes: "Enregistrer les Modifications",
    cancel: "Annuler",
    error_load: "Impossible de charger les membres de l'équipe.",
    error_create: "Impossible d'ajouter l'utilisateur.",
    error_update: "Impossible de mettre à jour l'utilisateur.",
    error_delete: "Impossible de supprimer l'utilisateur.",
    success_create: "Utilisateur ajouté avec succès.",
    limit_reached: "Limite d'utilisateurs atteinte",
    upgrade: "Mettre à niveau",
    error_required_fields: "Veuillez remplir tous les champs obligatoires.",
    error_password_mismatch: "Les mots de passe ne correspondent pas.",
    password_requirements_hint:
      "Le mot de passe doit comporter au moins 8 caractères et inclure 1 majuscule, 1 minuscule et 1 chiffre.",
    delete_user_title: "Supprimer l'utilisateur",
    delete_user_description: "Êtes-vous sûr de vouloir supprimer {{name}} ?",
    delete_user: "Supprimer l'utilisateur",
    generate_password: "Générer un mot de passe fort",
    show_password: "Afficher le mot de passe",
    hide_password: "Masquer le mot de passe",
  },
  it: {
    title: "Membri del Team",
    description: "Gestire il team e i permessi di accesso",
    add_user: "Aggiungi Utente",
    all_team_members: "Tutti i Membri del Team",
    members_count: "membro",
    members_count_plural: "membri",
    in_your_team: "nel tuo team",
    add_user_title: "Aggiungi utente",
    add_user_description: "Aggiungere un nuovo membro all'organizzazione",
    first_name: "Nome",
    last_name: "Cognome",
    email: "Email",
    password: "Password",
    confirm_password: "Conferma password",
    permissions: "Permessi",
    owner: "Proprietario",
    admin: "Amministratore",
    user: "Membro",
    read_only: "Solo Lettura",
    role_admin_desc: "Accesso illimitato a tutti i conti finanziari.",
    role_user_desc: "Accesso limitato ai conti finanziari.",
    role_readonly_desc: "Accesso in sola lettura al flusso di cassa e ai rapporti.",
    edit_user_title: "Modifica utente",
    edit_user_description: "Aggiornare le informazioni del membro del team",
    save_changes: "Salva Modifiche",
    cancel: "Annulla",
    error_load: "Impossibile caricare i membri del team.",
    error_create: "Impossibile aggiungere l'utente.",
    error_update: "Impossibile aggiornare l'utente.",
    error_delete: "Impossibile rimuovere l'utente.",
    success_create: "Utente aggiunto con successo.",
    limit_reached: "Limite utenti raggiunto",
    upgrade: "Aggiorna",
    error_required_fields: "Compila tutti i campi obbligatori.",
    error_password_mismatch: "Le password non corrispondono.",
    password_requirements_hint:
      "La password deve avere almeno 8 caratteri e includere 1 maiuscola, 1 minuscola e 1 numero.",
    delete_user_title: "Elimina utente",
    delete_user_description: "Sei sicuro di voler eliminare {{name}}?",
    delete_user: "Elimina utente",
    generate_password: "Genera password forte",
    show_password: "Mostra password",
    hide_password: "Nascondi password",
  },
  nl: {
    title: "Teamleden",
    description: "Beheer uw team en toegangsrechten",
    add_user: "Gebruiker Toevoegen",
    all_team_members: "Alle Teamleden",
    members_count: "lid",
    members_count_plural: "leden",
    in_your_team: "in uw team",
    add_user_title: "Gebruiker toevoegen",
    add_user_description: "Een nieuw lid toevoegen aan uw organisatie",
    first_name: "Voornaam",
    last_name: "Achternaam",
    email: "E-mail",
    password: "Wachtwoord",
    confirm_password: "Bevestig wachtwoord",
    permissions: "Rechten",
    owner: "Eigenaar",
    admin: "Beheerder",
    user: "Lid",
    read_only: "Alleen Lezen",
    role_admin_desc: "Onbeperkte toegang tot alle financiële rekeningen.",
    role_user_desc: "Beperkte toegang tot financiële rekeningen.",
    role_readonly_desc: "Alleen-lezen toegang tot cashflow en rapporten.",
    edit_user_title: "Gebruiker bewerken",
    edit_user_description: "Informatie van teamlid bijwerken",
    save_changes: "Wijzigingen Opslaan",
    cancel: "Annuleren",
    error_load: "Kan teamleden niet laden.",
    error_create: "Kan gebruiker niet toevoegen.",
    error_update: "Kan gebruiker niet bijwerken.",
    error_delete: "Kan gebruiker niet verwijderen.",
    success_create: "Gebruiker toegevoegd.",
    limit_reached: "Gebruikerslimiet bereikt",
    upgrade: "Upgraden",
    error_required_fields: "Vul alle verplichte velden in.",
    error_password_mismatch: "Wachtwoorden komen niet overeen.",
    password_requirements_hint:
      "Wachtwoord moet minimaal 8 tekens zijn en 1 hoofdletter, 1 kleine letter en 1 cijfer bevatten.",
    delete_user_title: "Gebruiker verwijderen",
    delete_user_description: "Weet je zeker dat je {{name}} wilt verwijderen?",
    delete_user: "Gebruiker verwijderen",
    generate_password: "Sterk wachtwoord genereren",
    show_password: "Wachtwoord tonen",
    hide_password: "Wachtwoord verbergen",
  },
  sv: {
    title: "Teammedlemmar",
    description: "Hantera ditt team och åtkomsträttigheter",
    add_user: "Lägg till Användare",
    all_team_members: "Alla Teammedlemmar",
    members_count: "medlem",
    members_count_plural: "medlemmar",
    in_your_team: "i ditt team",
    add_user_title: "Lägg till användare",
    add_user_description: "Lägg till en ny medlem i din organisation",
    first_name: "Förnamn",
    last_name: "Efternamn",
    email: "E-post",
    password: "Lösenord",
    confirm_password: "Bekräfta lösenord",
    permissions: "Behörigheter",
    owner: "Ägare",
    admin: "Administratör",
    user: "Medlem",
    read_only: "Endast Läsning",
    role_admin_desc: "Obegränsad åtkomst till alla finansiella konton.",
    role_user_desc: "Begränsad åtkomst till finansiella konton.",
    role_readonly_desc: "Läsbehörighet till kassaflöde och rapporter.",
    edit_user_title: "Redigera användare",
    edit_user_description: "Uppdatera information för teammedlem",
    save_changes: "Spara Ändringar",
    cancel: "Avbryt",
    error_load: "Det gick inte att ladda teammedlemmar.",
    error_create: "Det gick inte att lägga till användaren.",
    error_update: "Det gick inte att uppdatera användaren.",
    error_delete: "Det gick inte att ta bort användaren.",
    success_create: "Användare har lagts till.",
    limit_reached: "Användargränsen är nådd",
    upgrade: "Uppgradera",
    error_required_fields: "Fyll i alla obligatoriska fält.",
    error_password_mismatch: "Lösenorden matchar inte.",
    password_requirements_hint:
      "Lösenordet måste vara minst 8 tecken och innehålla 1 versal, 1 gemen och 1 siffra.",
    delete_user_title: "Ta bort användare",
    delete_user_description: "Är du säker på att du vill ta bort {{name}}?",
    delete_user: "Ta bort användare",
    generate_password: "Generera starkt lösenord",
    show_password: "Visa lösenord",
    hide_password: "Dölj lösenord",
  },
  da: {
    title: "Teammedlemmer",
    description: "Administrer dit team og adgangsrettigheder",
    add_user: "Tilføj Bruger",
    all_team_members: "Alle Teammedlemmer",
    members_count: "medlem",
    members_count_plural: "medlemmer",
    in_your_team: "i dit team",
    add_user_title: "Tilføj bruger",
    add_user_description: "Tilføj et nyt medlem til din organisation",
    first_name: "Fornavn",
    last_name: "Efternavn",
    email: "E-mail",
    password: "Adgangskode",
    confirm_password: "Bekræft adgangskode",
    permissions: "Rettigheder",
    owner: "Ejer",
    admin: "Administrator",
    user: "Medlem",
    read_only: "Kun Læsning",
    role_admin_desc: "Ubegrænset adgang til alle finansielle konti.",
    role_user_desc: "Begrænset adgang til finansielle konti.",
    role_readonly_desc: "Skrivebeskyttet adgang til pengestrøm og rapporter.",
    edit_user_title: "Rediger bruger",
    edit_user_description: "Opdater information for teammedlem",
    save_changes: "Gem Ændringer",
    cancel: "Annuller",
    error_load: "Kunne ikke indlæse teammedlemmer.",
    error_create: "Kunne ikke tilføje brugeren.",
    error_update: "Kunne ikke opdatere brugeren.",
    error_delete: "Kunne ikke fjerne brugeren.",
    success_create: "Bruger tilføjet.",
    limit_reached: "Brugergrænsen er nået",
    upgrade: "Opgrader",
    error_required_fields: "Udfyld alle obligatoriske felter.",
    error_password_mismatch: "Adgangskoderne matcher ikke.",
    password_requirements_hint:
      "Adgangskoden skal være mindst 8 tegn og indeholde 1 stort bogstav, 1 lille bogstav og 1 tal.",
    delete_user_title: "Slet bruger",
    delete_user_description: "Er du sikker på, at du vil slette {{name}}?",
    delete_user: "Slet bruger",
    generate_password: "Generer stærkt kodeord",
    show_password: "Vis adgangskode",
    hide_password: "Skjul adgangskode",
  },
  fi: {
    title: "Tiimin Jäsenet",
    description: "Hallitse tiimiäsi ja käyttöoikeuksia",
    add_user: "Lisää Käyttäjä",
    all_team_members: "Kaikki Tiimin Jäsenet",
    members_count: "jäsen",
    members_count_plural: "jäsentä",
    in_your_team: "tiimissäsi",
    add_user_title: "Lisää käyttäjä",
    add_user_description: "Lisää uusi jäsen organisaatioon",
    first_name: "Etunimi",
    last_name: "Sukunimi",
    email: "Sähköposti",
    password: "Salasana",
    confirm_password: "Vahvista salasana",
    permissions: "Oikeudet",
    owner: "Omistaja",
    admin: "Ylläpitäjä",
    user: "Jäsen",
    read_only: "Vain Luku",
    role_admin_desc: "Rajoittamaton pääsy kaikkiin taloudellisiin tileihin.",
    role_user_desc: "Rajoitettu pääsy taloudellisiin tileihin.",
    role_readonly_desc: "Lukuoikeus kassavirtaan ja raportteihin.",
    edit_user_title: "Muokkaa käyttäjää",
    edit_user_description: "Päivitä tiimin jäsenen tiedot",
    save_changes: "Tallenna Muutokset",
    cancel: "Peruuta",
    error_load: "Tiimin jäseniä ei voitu ladata.",
    error_create: "Käyttäjää ei voitu lisätä.",
    error_update: "Käyttäjää ei voitu päivittää.",
    error_delete: "Käyttäjää ei voitu poistaa.",
    success_create: "Käyttäjä lisätty.",
    limit_reached: "Käyttäjäraja saavutettu",
    upgrade: "Päivitä",
    error_required_fields: "Täytä kaikki pakolliset kentät.",
    error_password_mismatch: "Salasanat eivät täsmää.",
    password_requirements_hint:
      "Salasanan tulee olla vähintään 8 merkkiä ja sisältää 1 iso kirjain, 1 pieni kirjain ja 1 numero.",
    delete_user_title: "Poista käyttäjä",
    delete_user_description: "Haluatko varmasti poistaa {{name}}?",
    delete_user: "Poista käyttäjä",
    generate_password: "Luo vahva salasana",
    show_password: "Näytä salasana",
    hide_password: "Piilota salasana",
  },
};
